<template>
  <section v-if="!property.is_active">
    <LsInfoCard
      v-if="isPaymentFailure"
      class="ls-reactivate-card payment-failure"
      danger
      test-id="paymentFailureBanner"
    >
      <h4 class="has-text-weight-bold">You have no upcoming Lawn Mowing services</h4>
      <p class="ls-reactivate-card--p" style="margin-bottom: 15px;">
        The charge for your last service didn't go through, so your services have been canceled for
        non-payment. Activate your services to order lawn care.
      </p>
      <LsButton
        text="activate your services"
        bg-color="danger"
        track-id="ls_reactivate_card-activate_your_services"
        test-id="paymentFailureButton"
        @click.native="goToReactivation"
      />
    </LsInfoCard>
    <LsInfoCard v-else class="ls-reactivate-card" test-id="reactivationBanner">
      <div v-if="property.can_self_reactivate" class="ls-reactivate-card--can-self-reactivate">
        <h4 class="has-text-weight-bold">You have no upcoming Lawn Mowing services</h4>
        <p class="ls-reactivate-card--p" style="margin-bottom: 15px;">
          Activate your services to order lawn care
        </p>
        <LsButton
          text="activate your services"
          bg-color="primary"
          track-id="ls_reactivate_card-activate_your_services"
          test-id="reactivationButton"
          @click.native="goToReactivation"
        />
      </div>
      <p v-if="!property.can_self_reactivate">
        Service is not currently available in your area. We're adding availability all the time
        though so check back soon!
      </p>
    </LsInfoCard>
  </section>
</template>

<script>
import { LsButton, LsInfoCard } from '@/components/common';
import VueTypes from 'vue-types';
import { PROPERTY_DEACTIVATED_REASONS } from '@/constants/property';

export default {
  name: 'LsReactivateCard',
  components: {
    LsButton,
    LsInfoCard,
  },
  props: {
    property: VueTypes.shape({
      is_active: VueTypes.bool.isRequired,
      property_id: VueTypes.integer.isRequired,
      can_self_reactivate_reason: VueTypes.oneOfType([null, VueTypes.string]),
      can_self_reactivate: VueTypes.bool.isRequired,
    }).isRequired.loose,
  },
  computed: {
    isPaymentFailure() {
      const { can_self_reactivate_reason } = this.property;

      return can_self_reactivate_reason === PROPERTY_DEACTIVATED_REASONS.PAYMENT_FAILURE;
    },
  },
  methods: {
    goToReactivation() {
      this.$router.push({
        name: 'reactivate',
        params: {
          property_id: this.property.property_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-reactivate-card {
  margin-bottom: 20px;
  @media (max-width: $mobile-max-width) {
    margin-top: 30px;
  }
  // following class is conditionally added by LsInfoCard component
  &.themed-component {
    .ls-reactivate-card--p {
      color: $theme-color-primary;
    }
  }
}

.ls-reactivate-card.payment-failure {
  flex-direction: column;
  align-items: flex-start;
  // following class is conditionally added by LsInfoCard component
  &.themed-component {
    .ls-reactivate-card--p {
      color: $gray-primary;
    }
  }
  & > h4 {
    color: $theme-color-danger;
    text-transform: uppercase;
  }
}

.ls-reactivate-card--can-self-reactivate {
  width: 100%;
}

.ls-reactivate-card--p {
  color: $primary;
}
.themed-app {
  .ls-reactivate-card--p {
    color: $theme-color-primary;
  }
}
</style>
